import { ReactElement, Suspense } from 'react';
import PageLayout from '../../../components/PageLayout';
import MainContent from '../../../components/MainContent';
import SideBar from '../../../components/SideBar';
import Header from './components/Header';
import Loading from '../../../components/Loading';
import Content from './components/Content';

const CustomerDetailPage = (): ReactElement => (
  <PageLayout
    sidebar={<SideBar />}
    mainContent={
      <MainContent
        header={<Header title='顧客詳細' />}
        content={
          <Suspense fallback={<Loading />}>
            <Content />
          </Suspense>
        }
      />
    }
  />
);

export default CustomerDetailPage;
